import { initSentry } from '@imt/vue-toolbox/src/plugins/sentry';
import * as Sentry from '@sentry/vue';
import Vue from 'vue';

initSentry({
    Vue,
    dsn: 'https://fac5bcda37d04449b14cee0f051b8758@o527262.ingest.sentry.io/5818443',
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.vueIntegration({
            tracingOptions: {
                trackComponents: true,
            },
        }),
    ],
    tracesSampleRate: 1.0,
});
